import { useState, useCallback } from 'react';

export interface UseBriefEditSuccessModalReturn {
    isOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
}

export const useBriefEditSuccessModal = (): UseBriefEditSuccessModalReturn => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    return {
        isOpen,
        openModal,
        closeModal,
    };
};
